import type { ProductFormWrapperProps } from './product-form-wrapper.component';

/**
 * Maps HTML attribute names (kebab-case) to ProductFormWrapperProps prop names (camelCase)
 */
export const PRODUCT_FORM_WRAPPER_ATTRIBUTE_MAP: Record<string, keyof ProductFormWrapperProps> = {
  'product-id': 'productId',
  'gated-product': 'gatedProduct',
  'membership-product': 'membershipProduct',
  'upsell-product': 'upsellProduct',
  'button-full-width': 'buttonFullWidth',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'gatedProduct',
  'membershipProduct',
  'upsellProduct',
  'buttonFullWidth',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to ProductFormWrapperProps props
 */
export function extractProductFormWrapperAttributes(
  element: HTMLElement
): Partial<ProductFormWrapperProps> {
  const props: Partial<ProductFormWrapperProps> = {};

  for (const [attrName, propName] of Object.entries(PRODUCT_FORM_WRAPPER_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
